import React from "react";
import DashBoard from "./Components/index";
import { fromDaily, toDaily } from "fuction/date";
import { withRouter } from "react-router";
import queryString from "query-string";
import useAuth from "Hooks/useAuth";

function Page(props) {
  const auth = useAuth();
  const activeGroup = auth.state.activeGroup;
  const fromDate = fromDaily(queryString.parse(props.location.search).date);
  const toDate = toDaily(queryString.parse(props.location.search).date);

  const onClickLineChart = (date) => {
    props.history.push(`/dashboard/hourly?activeGroup=${activeGroup}&date=${date}`);
  };
  const onClickListButton = (date) => {
    props.history.push(`/dashboard/details?activeGroup=${activeGroup}&date=${date}&interval=daily`);
  };
  const onClickReTweet = (id, date) => {
    props.history.push(
      `/retweets/daily?activeGroup=${activeGroup}&id=${id}&date=${date}`
    );
  };
  const onClickUser = (screen_name) => {
    props.history.push(`/users/details?activeGroup=${activeGroup}&user=${screen_name}&dateTo=${toDate}&dateFrom=${fromDate}`);
  };
  const onClickKeyword = (word, date) => {
    props.history.push(`/keywords/daily?activeGroup=${activeGroup}&word=${word}&date=${date}`);
  };
  const handleChangeDateSingle = (date) => {
    props.history.push(`/dashboard/daily?activeGroup=${activeGroup}&date=${date}`);
  };

  return (
    <DashBoard
      fromDate={fromDate}
      toDate={toDate}
      unit="hour"
      target="daily"
      onClickLineChart={onClickLineChart}
      onClickListButton={onClickListButton}
      onClickReTweet={onClickReTweet}
      onClickUser={onClickUser}
      onClickKeyword={onClickKeyword}
      handleChangeDateSingle={handleChangeDateSingle}
    />
  );
}

export default withRouter(Page);
